// hooks/useSearchFilter.js (ملف جديد للـ custom hook)
import { useState, useEffect } from 'react';

export const useSearchFilter = (data, searchTerm, filterKeys = []) => {
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredData(data);
    } else {
      const lowerSearch = searchTerm.toLowerCase();
      const filtered = data.filter(item => 
        filterKeys.some(key => {
          const value = item[key];
          if (Array.isArray(value)) {
            return value.some(v => 
              v?.toString().toLowerCase().includes(lowerSearch)
            );
          } else {
            return value?.toString().toLowerCase().includes(lowerSearch);
          }
        })
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, data, filterKeys]);

  return filteredData;
};